function snakeCaseToCamelCaseKey(snakeCase: string) {
  return snakeCase
    .toLowerCase()
    .split('-')
    .map((val: string, index: number) => {
      if (index === 0) return val
      return val.substring(0, 1).toUpperCase() + val.substring(1, val.length)
    })
    .join('')
}

export default snakeCaseToCamelCaseKey
